import { useDownload } from '@/helpers/download'
import api from './api'

export default {    
    
    count(params = {}) {

        return api.get('/archives', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    getFile(id) {

        return new Promise((resolve, reject) => {

            api.post('/archives/' + id + '/file')
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun document à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
            })
    },

    getTypes() {

        return api.get('/archives/types')
            .then( json => json.data )  
    },

    list(params = {}) {

        return api.get('/archives', { params })
            .then( json => json.data )
            
    },

    search(params = {}) {

        return api.get('/archives', { params })
            .then( json => json.data )            
    } 
}
